$ = require('jquery')

module.exports =
	init: (payload) ->
        {$target} = payload

        $this = $(this)
        $menu = $('.m-product')
        $menuList = $menu.find('.m-product__wrap')

        $(window)
            .on 'scroll', ->
                if $menu.length > 0
                    if $target.scrollTop() > $menu.offset().top
                        $menuList.addClass 'is-fixed'
                    else
                        $menuList.removeClass 'is-fixed'
        return


// WEBPACK FOOTER //
// ./src/js/components/fixedMenu.coffee